import { useEffect, useState } from "react";
import styles from '../styles/CustomError.module.css';

const CustomError = ({txt}) => {
  return(
    <div className={styles.holder}>
      <h1 className={styles.errorCode}>404</h1>
      <h2 className={styles.errorMsg}>{txt}</h2>
    </div>
  );
}

export default CustomError;